// Import models.
import TableData, { TableDataParameters } from './TableData';

interface TableDataWithImmutableDataParameters<TDataType extends any = any> extends TableDataParameters<TDataType> {
    immutableData?: TDataType[];
}

class TableDataWithImmutableData<TDataType extends any = any> extends TableData<TDataType> {
    public immutableData: TDataType[];

    public constructor(params: TableDataWithImmutableDataParameters<TDataType>) {
        super(params);
        this.immutableData = params.immutableData ?? [];
    }
}

export default TableDataWithImmutableData;